import { map } from "lodash";
import React from "react";

import { formatDate, formatTime, parseTimestamp } from "../../../utils/dateFns";

import {
  Column,
  ColumnContentWrapper,
  FlexWrapper,
  Header,
  HeaderRow,
  Row,
  Table,
  TBody,
  THead,
} from "./styles";

const ListLogTable = (props) => {
  const HeaderColumn = (headerProps) => {
    const { children, width } = headerProps;

    return (
      <Header width={width} clickable={false}>
        <FlexWrapper justify="space-between">{children}</FlexWrapper>
      </Header>
    );
  };

  const renderHeader = () => {
    return (
      <THead>
        <HeaderRow>
          <HeaderColumn id="tipoAcaoEnum" width="85px">
            Tipo da Ação
          </HeaderColumn>
          <HeaderColumn id="pessoaNome">Pessoa</HeaderColumn>
          <HeaderColumn id="dataRegistro" width="140px">
            Data de Registro
          </HeaderColumn>
        </HeaderRow>
      </THead>
    );
  };

  const renderBody = () => {
    const { logs } = props;

    return (
      <TBody>
        {map(logs, (it) => {
          const parsedDate = parseTimestamp(it.dataRegistro);
          return (
            <Row key={it.id}>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.tipoAcaoEnum}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.pessoaNome}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatDate(parsedDate)} {formatTime(parsedDate)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
            </Row>
          );
        })}
      </TBody>
    );
  };

  return (
    <Table>
      {renderHeader()}
      {renderBody()}
    </Table>
  );
};

export default ListLogTable;
